export type SocialPlatform = 'instagram' | 'tiktok' | 'twitter' | 'facebook';
export type Group = 'tss' | 'tsw';

export const SOCIAL_MEDIA_URLS: {
  tss: Record<SocialPlatform | 'youtube', string>;
  tsw: Record<SocialPlatform, string>;
} = {
  tss: {
    facebook: 'https://www.facebook.com/thesolesupplier/',
    instagram: 'https://www.instagram.com/thesolesupplier/',
    tiktok: 'https://www.tiktok.com/@thesolesupplier',
    twitter: 'https://x.com/thesolesupplier',
    youtube: 'https://www.youtube.com/user/thesolesupplier'
  },
  tsw: {
    facebook: 'https://www.facebook.com/thesolewomens/',
    instagram: 'https://www.instagram.com/thesolewomens/',
    tiktok: 'https://www.tiktok.com/@thesolewomens',
    twitter: 'https://x.com/TheSoleWomens'
  }
};

export const SOCIAL_HANDLES: Record<Group, string> = {
  tss: '@thesolesupplier',
  tsw: '@thesolewomens'
};
